import React, { useCallback, useState } from 'react';
import { Button, Clickable, Stack } from '@moda/om';
import ExitIcon from '@moda/icons/exit-20';
import ChevronRightIcon from '@moda/icons/chevron-right-16';
import ChevronLeftIcon from '@moda/icons/chevron-left-20';
import { Modal } from '../Modal';
import './PageFilterPanel.scss';

type PageFilterPanelProps = {
  onClose: () => void;
  title: string;
};

export const PageFilterPanel: React.FC<PageFilterPanelProps> = ({ children, onClose, title }) => {
  const [panelOpen, setPanelOpen] = useState(false);
  const togglePanelOpen = useCallback(() => setPanelOpen(!panelOpen), [panelOpen]);

  return panelOpen ? (
    <Modal className="PageFilterPanel__modal" onClose={onClose}>
      <Stack space={0} className="PageFilterPanel__wrapper">
        <div className="PageFilterPanel__header">
          <Clickable className="PageFilterPanel__close" onClick={onClose}>
            <ExitIcon />
          </Clickable>
          <Clickable className="PageFilterPanel__back" onClick={togglePanelOpen}>
            <ChevronLeftIcon />
          </Clickable>
          <div className="PageFilterPanel__title">{title}</div>
        </div>
        <div className="PageFilterPanel__content">{children}</div>
        <Button className="PageFilterPanel__submit" onClick={onClose}>
          APPLY
        </Button>
      </Stack>
    </Modal>
  ) : (
    <div className="PageFilterPanel">
      <Clickable className="PageFilterPanel__button" onClick={togglePanelOpen}>
        <h4 className="PageFilterPanel__buttonText">{title}</h4>
        <div className="PageFilterPanel__open">
          <ChevronRightIcon />
        </div>
      </Clickable>
    </div>
  );
};
